import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=2a0b26d3&scoped=true"
import script from "./sidebarMenu.vue?vue&type=script&lang=js"
export * from "./sidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=2a0b26d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b26d3",
  null
  
)

export default component.exports